import { call, fork, put, takeEvery } from 'redux-saga/effects';
import SweetAlert from '../../../../components/sweetalert/SweetAlert';

import * as types from './RawExamActionType';
import * as actions from './RawExamAction';
import * as services from './RawExamService';

//------------------ Raw Exam Data - start------------------//
function* fetchRawExamDataSaga(action) {
    try {
        const response = yield call(services.getAllRawExamData, action.payload);
        if (!response) {
            throw new Error('No response received from API');
        }
        yield put(actions.fetchRawExamDataSuccess(response?.values));
    } catch (error) {
        let errorMessage = 'Failed to fetch raw exam data.';
        console.error('Raw Exam Data API Error:', {

            status: error.response?.status,
            message: errorMessage,
            data: error.response?.data,
            timestamp: new Date().toISOString()
        });
        yield put(actions.fetchRawExamDataFailure(errorMessage));
    }
}

function* refreshRawExamDataSaga(action) {
    try {
        const response = yield call(services.refreshRawExamData, action.payload);
        yield put(actions.refreshRawExamDataSuccess(response?.values));

        if (response && response.success) {
            SweetAlert.success({
                title: 'Success!',
                text: response?.resultMessage || 'Refreshed successfully.'
            });
        }else {
            SweetAlert.error({
                title: 'Error!',
                text: response?.errorMessage || 'Failed to refresh data.'
            });
        }
    } catch (error) {
        let errorMessage = 'Failed to refresh raw exam data.';
        yield put(actions.refreshRawExamDataFailure(errorMessage));
        SweetAlert.error({
            title: 'Error!',
            text: errorMessage
        });
    }
}
//------------------ Raw Exam Data - end------------------//

export default function* watchRawExamSaga() {
    yield takeEvery(types.FETCH_RAW_EXAM_DATA_REQUEST, fetchRawExamDataSaga);
    yield takeEvery(types.REFRESH_RAW_EXAM_DATA_REQUEST, refreshRawExamDataSaga);
}